import { COLORS } from '../../../../utils/colors';
import { Box, Typography, Button, styled, Divider } from '@mui/material';

export const useScheduleCardDetailsStyles = () => {
  return {
    cardHeader: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      bgcolor: COLORS.WHITE,
      padding: '1.3125rem 1.875rem',
    },
    detailsHeading: {
      fontSize: '0.75rem',
      fontWeight: 'bold',
      padding: '0.5rem 0',
    },
    pastInspectionDate: {
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    reEnterSession: {
      color: 'inherit',
      fontWeight: 500,
      fontSize: '0.875rem',
      marginRight: '1.125rem',
    },
    vhcButton: {
      fontWeight: 500,
      color: '#888',
      marginRight: '0.625rem',
    },
    baseButton: {
      fontWeight: 500,
      color: '#FF6E00',
      textTransform: 'none',
      margin: '0 0.625rem',
      //backgroundColor: COLORS.LIGHT_GRAY,
    },
    statusSelectBox: {
      display: 'inline-flex',
      alignItems: 'center',
      mr: 1,
      ml: '1rem',
    },
    statusSelect: {
      transform: 'translateY(.3rem)',
      minWidth: 120,
      '& .MuiInput-underline:before': {
        borderBottom: 'none',
      },
      '& .MuiInput-underline:after': {
        borderBottom: 'none',
      },
    },
    rescheduleButton: {
      color: '#FF6E00',
    },
    cancelButton: {
      color: COLORS.RED,
    },
    completeButton: {
      color: COLORS.GREEN,
    },
    cardOverflow: {
      overflowY: 'auto',
      overflowX: 'hidden',
      maxHeight: 'calc(100vh - 16rem)',
      padding: '0.5rem 0.75rem',
    },
    pre: {
      width: 'calc(100% - 2.375rem)',
      padding: '.5rem',
      margin: 0,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      backgroundColor: '#eee',
      fontSize: '0.875rem',
    },
    mediaStatusItem: {
      padding: '.5rem 0',
      display: 'flex',
      alignItems: 'center',
    },
    arrowIcon: {
      marginLeft: '0.5rem',
      color: COLORS.PRIMARY,
      '&:hover': { opacity: 0.8 },
    },
    file: {
      fontSize: '0.875rem',
      display: 'flex',
      alignItems: 'center',
      lineHeight: '1',
    },
    filelist: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      maxHeight: '10rem',
      overflow: 'auto',
      width: 'calc(100% - 1rem)',
      paddingLeft: '1rem',
      paddingBottom: '1rem',
    },
    filename: {
      flex: 1,
      cursor: 'pointer',
      '&:hover': {
        color: 'rgba(0, 0, 255, 0.5)',
      },
    },
    mediaStatusList: {
      maxHeight: 'min(30rem, 50vh)',
      overflowY: 'auto',
      width: '100%',
      margin: '0',
      padding: '0 1rem',
    },
  };
};

export const StyledWrapper = styled(Box)({
  width: '47%',
  boxShadow:
    '0 0.3125rem 0.9375rem 0 rgba(0, 0, 0, 0.07), 0 0.625rem 1.5625rem 0 rgba(50, 50, 93, 0.07)',
  backgroundColor: COLORS.LIGHT_GRAY,
  position: 'fixed',
  right: '2.25rem',
});

export const StyledButton = styled(Button)({
  fontWeight: 600,
  borderRadius: '1.625rem',
  backgroundImage: 'linear-gradient(to bottom right, #ff9e54, #ff6e00)',
  fontSize: '1rem',
  padding: '0.3125rem 2rem',
});

export const StyledDateText = styled(Typography)({
  fontSize: '0.9375rem',
  fontWeight: 600,
  color: COLORS.TEXT,
});

export const StyledDivider = styled(Divider)({
  margin: '0.75rem 1.875rem 0 1.875rem',
});
